<template>
  <div class="subcontractor-users">
    <div class="page-header">
      <h3 class="intern-title ml-3">
        <back-arrow />
        <span class="page-nav">{{ $t("vinculatedUsers") }}</span>
      </h3>
      <Button
        class="ml-2"
        @clicked="newUserToSubcontractor()"
        :name="$t('vinculateUser')"
        size="small mb-4"
      />
    </div>
    <div class="w-25 mt-4 mb-4 ml-3">
      <Input
        v-model="searchString"
        :placeholder="$t('searchUser')"
        :search="true"
      />
    </div>
    <transition name="bounce">
      <div v-if="!loadingData">
        <Table :fields="fields" :hasActions="true">
          <TableRow
            v-for="item in subcontractorUsers"
            :key="item.usuario_id + Math.random()"
          >
            <TableCell
              v-for="field in fields"
              :key="field.key"
              :name="field.key"
              :style="field._style"
              :sort-direction="field.sortDirection"
            >
              <template v-slot:[field.key]>
                <span class="table-row-text">{{
                  item[field.key] || "--"
                }}</span>
              </template>
              <template v-slot:zeladoria>
                <div
                  class="keeping-sector-badge"
                  v-if="item.zeladoria_nome !== null"
                >
                  <div>
                    {{ item.zeladoria_nome }}
                  </div>
                  <div
                    @click="deleteKeepingSectorFromUser(item)"
                    class="fix-badge"
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.3333 2.99967H13.6666V4.33301H12.3333V12.9997C12.3333 13.1765 12.263 13.3461 12.138 13.4711C12.013 13.5961 11.8434 13.6663 11.6666 13.6663H2.33325C2.15644 13.6663 1.98687 13.5961 1.86185 13.4711C1.73682 13.3461 1.66659 13.1765 1.66659 12.9997V4.33301H0.333252V2.99967H3.66659V0.999674C3.66659 0.822863 3.73682 0.653294 3.86185 0.52827C3.98687 0.403246 4.15644 0.333008 4.33325 0.333008H9.66659C9.8434 0.333008 10.013 0.403246 10.138 0.52827C10.263 0.653294 10.3333 0.822863 10.3333 0.999674V2.99967ZM10.9999 4.33301H2.99992V12.333H10.9999V4.33301ZM4.99992 6.33301H6.33325V10.333H4.99992V6.33301ZM7.66659 6.33301H8.99992V10.333H7.66659V6.33301ZM4.99992 1.66634V2.99967H8.99992V1.66634H4.99992Z"
                        fill="#838998"
                      />
                    </svg>
                  </div>
                </div>
                <div v-else>
                  <div
                    @click="
                      $router.push({
                        name: 'AssociarZeladoria',
                        params: { id: item.usuario_id },
                      })
                    "
                    class="keeping-sector-badge"
                  >
                    <div>Vincular</div>
                    <span>
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.70659 4.40715L8.64993 5.35048C9.08332 5.78383 9.4271 6.2983 9.66166 6.86451C9.89621 7.43073 10.0169 8.03761 10.0169 8.65048C10.0169 9.26336 9.89621 9.87023 9.66166 10.4364C9.4271 11.0027 9.08332 11.5171 8.64993 11.9505L8.41393 12.1858C7.53871 13.061 6.35167 13.5527 5.11393 13.5527C3.87619 13.5527 2.68914 13.061 1.81393 12.1858C0.938712 11.3106 0.447021 10.1236 0.447021 8.88581C0.447021 7.64807 0.938712 6.46103 1.81393 5.58581L2.75726 6.52915C2.44551 6.83818 2.19786 7.20575 2.02855 7.61075C1.85923 8.01575 1.77157 8.4502 1.77061 8.88917C1.76965 9.32814 1.8554 9.76297 2.02294 10.1687C2.19049 10.5744 2.43652 10.9431 2.74691 11.2535C3.05731 11.5639 3.42596 11.8099 3.8317 11.9775C4.23744 12.145 4.67227 12.2308 5.11124 12.2298C5.5502 12.2288 5.98466 12.1412 6.38966 11.9719C6.79466 11.8025 7.16222 11.5549 7.47126 11.2431L7.70726 11.0071C8.33216 10.3821 8.68321 9.53436 8.68321 8.65048C8.68321 7.7666 8.33216 6.91891 7.70726 6.29381L6.76393 5.35048L7.70726 4.40781L7.70659 4.40715ZM12.1853 8.41448L11.2426 7.47181C11.5543 7.16278 11.802 6.79521 11.9713 6.39021C12.1406 5.98521 12.2283 5.55076 12.2292 5.11179C12.2302 4.67282 12.1445 4.23799 11.9769 3.83225C11.8094 3.42652 11.5633 3.05787 11.2529 2.74747C10.9425 2.43707 10.5739 2.19104 10.1682 2.0235C9.76242 1.85596 9.32758 1.7702 8.88862 1.77117C8.44965 1.77213 8.0152 1.85978 7.6102 2.0291C7.2052 2.19842 6.83763 2.44606 6.52859 2.75781L6.29259 2.99381C5.66769 3.61891 5.31664 4.4666 5.31664 5.35048C5.31664 6.23436 5.66769 7.08205 6.29259 7.70715L7.23593 8.65048L6.29259 9.59315L5.34993 8.65048C4.91654 8.21713 4.57275 7.70266 4.3382 7.13645C4.10365 6.57023 3.98292 5.96336 3.98292 5.35048C3.98292 4.7376 4.10365 4.13073 4.3382 3.56451C4.57275 2.9983 4.91654 2.48383 5.34993 2.05048L5.58593 1.81515C6.46114 0.939933 7.64819 0.448242 8.88593 0.448242C10.1237 0.448242 11.3107 0.939933 12.1859 1.81515C13.0611 2.69036 13.5528 3.87741 13.5528 5.11515C13.5528 6.35289 13.0611 7.53993 12.1859 8.41515L12.1853 8.41448Z"
                          fill="#838998"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
              </template>
            </TableCell>
            <TableCell class="d-flex justify-content-end">
              <CondensedDropdown
                class="mt-1"
                @dropdown-click="(ev) => handleCondensedDropdownClick(ev, item)"
                :options="optionsByResearch(item)"
              />
            </TableCell>
          </TableRow>
          <template v-if="linkedUsers.length === 0" v-slot:no-results>
            <NoResults :message="$t('noResults')" />
          </template>
        </Table>
      </div>
    </transition>
    <infinite-loading @infinite="infiniteHandler">
      <div slot="spinner">
        <Loading />
      </div>
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>

    <Modal v-show="usersModal" :width="600" :height="300">
      <template v-slot:header>{{ $t("vinculateUser") }}</template>
      <template v-slot:body>
        <multiselect
          v-model="usersOfSubcontractor"
          :noOptions="$t('emptyList')"
          selectLabel=""
          :deselectLabel="$t('remove')"
          :selectedLabel="$t('selected')"
          :options="users"
          track-by="name"
          :placeholder="$t('selectUser')"
          :preselect-first="false"
          :multiple="true"
          label="name"
        ></multiselect>
      </template>
      <template v-slot:footer>
        <Button type="outline" :name="$t('save')" @clicked="addUsers" />
        <Button :name="$t('cancel')" @clicked="usersModal = false" />
      </template>
    </Modal>

    <Modal v-show="removeModal">
      <template v-slot:header>{{ $t("removeKeepingSector") }}</template>
      <template v-slot:body>
        <p style="color: #747474">
          {{ $t("confirmDeleteKeepingSector") }}
        </p>
      </template>
      <template v-slot:footer>
        <Button
          type="delete"
          :name="$t('save')"
          @clicked="removeKeepingSector"
        />
        <Button :name="$t('cancel')" @clicked="removeModal = false" />
      </template>
    </Modal>
  </div>
</template>

<script>
import Vue from "vue";
import Multiselect from "vue-multiselect";
import Button from "../../components/Button.vue";
import NoResults from "../../components/table/NoResults.vue";
import Table from "../../components/table/Table.vue";
import BackArrow from "../../components/BackArrow.vue";
import CondensedDropdown from "../../components/CondensedDropdown.vue";
import TableRow from "../../components/table/TableRow.vue";
import TableCell from "../../components/table/TableCell.vue";
import Loading from "../../components/IndexComponents/Loading.vue";
import Modal from "../../components/Modal.vue";
import Input from "../../components/form/Input.vue";

import services from "../../services";
import { formatPhone } from "../../utils/phone";
import { debounce } from "../../utils/debounce";

import { decrypt } from "../../utils/decrypt";

export default {
  name: "Subcontractors",
  components: {
    Multiselect,
    Button,
    Table,
    TableRow,
    CondensedDropdown,
    TableCell,
    Loading,
    NoResults,
    Modal,
    BackArrow,
    Input,
  },
  data() {
    return {
      fields: [
        {
          key: "usuario_nome",
          label: this.$t("name"),
          _style: "min-width:80px;",
        },
        {
          key: "usuario_email",
          label: this.$t("email"),
          _style: "min-width:70px;",
          sorteable: false,
          sortDirection: null,
        },
        {
          key: "usuario_telefone_formated",
          label: this.$t("phone"),
          _style: "min-width:90px;",
          sorteable: false,
          sortDirection: null,
        },
        {
          key: "zeladoria",
          label: this.$t("keepingSector"),
          _style: "min-width:80px;",
          sorteable: false,
          sortDirection: null,
        },
      ],
      deleteModal: false,
      subcontractorId: 0,
      loadingData: true,
      usersModal: false,
      userIdForRemoveKeepingSector: null,
      removeModal: false,
      users: [],
      usersOfSubcontractor: [],
      linkedUsers: [],
      subcontractorUsers: [],
      searchString: null,
      pagination: {
        page: 0,
        sortBy: null,
        filter: null,
        order: null,
      },
    };
  },
  mounted: async function () {
    this.subcontractorId = this.$route.params.id;
    await this.getSubcontractorUsers();
    await this.getUsersOfSubcontractors();
    await this.initUsers();
    this.loadingData = false;
  },
  watch: {
    searchString: debounce(async function (newVal) {
      this.pagination.page = 0;
      newVal
        ? (this.pagination.filter = newVal)
        : (this.pagination.filter = null);
      const { data, errors } =
        await services.subcontractors.getUsersOfSubcontractorsPaginated(
          this.subcontractorId,
          this.pagination
        );
      if (!errors) {
        this.subcontractorUsers = data;
      }
    }, 500),
  },
  methods: {
    newUserToSubcontractor() {
      this.usersOfSubcontractor = [];
      this.usersModal = true;
    },
    async handleCondensedDropdownClick(value, item) {
      if (value === "user-red" || value === "user-green") {
        await this.handleActiveUser(item);
      }
      if (value === "calendar") {
        this.$router.push({
          name: "CalendarioZelador",
          params: { id: item.usuario_id },
        });
        return;
      }
      if (value === "details") {
        this.$router.push({
          name: "DetalhesZelador",
          params: { id: item.usuario_id },
        });
        return;
      }
      if (value === "gallery") {
        this.$router.push({
          name: "GaleriaZelador",
          params: { id: item.usuario_id },
        });
        return;
      }
      this.loadingData = true;
      await this.getSubcontractorUsers();
      await this.getUsersOfSubcontractors();
      this.loadingData = false;
    },
    optionsByResearch(item) {
      if (item.subcontratada_usuario_ativo) {
        return [
          { label: "Ativar Zelador", value: "user-red" },
          { label: "Calendário", value: "calendar" },
          { label: "Detalhes", value: "details" },
          { label: "Galeria", value: "gallery" },
        ];
      } else {
        return [
          { label: "Desativar Zelador", value: "user-green" },
          { label: "Calendário", value: "calendar" },
          { label: "Detalhes", value: "details" },
          { label: "Galeria", value: "gallery" },
        ];
      }
    },
    async handleActiveUser(user) {
      const encrypted = localStorage.getItem("ama");
      const decrypted = await decrypt(encrypted);
      const userData = JSON.parse(decrypted);

      const { errors } =
        await services.subcontractors.updateStatusUserSubcontractor({
          subcontratada_id: parseInt(this.$route.params.id),
          usuario_id: user.usuario_id,
          subcontratada_usuario_ativo: user.subcontratada_usuario_ativo ? 0 : 1,
          usuario_gestor_id: userData.usuario_gestor_id,
        });
      if (!errors) {
        await this.getUsersOfSubcontractors();
        this.validationToast(
          {
            data: {
              message: this.$t("successChangeStatus"),
            },
          },
          "success"
        );
      }
    },
    async getUsersOfSubcontractors() {
      const { data, errors } =
        await services.subcontractors.getUsersOfSubcontractors(
          this.$route.params.id
        );
      if (!errors) {
        this.linkedUsers = [];
        data.map((item) => {
          this.linkedUsers.push({
            ...item,
            status: item.subcontratada_usuario_ativo
              ? this.$t("active")
              : this.$t("inactive"),
            usuario_telefone_formated: formatPhone(item.usuario_telefone),
          });
        });
      }
    },
    async addUsers() {
      await Promise.all(
        this.usersOfSubcontractor.map(async (item) => {
          const { errors } =
            await services.subcontractors.linkSubcontractorAndUser({
              usuario_id: item.usuario_id,
              subcontratada_id: parseInt(this.$route.params.id),
            });
          if (!errors) {
            this.validationToast(
              {
                data: {
                  message: this.$t("successAddLink"),
                },
              },
              "success"
            );
          } else {
            this.validationToast(
              {
                data: {
                  message: this.$t("errorAddLink"),
                },
              },
              "error"
            );
          }
        })
      );
      await this.getUsersOfSubcontractors();
      await this.initUsers();
      this.usersModal = false;
    },
    deleteKeepingSectorFromUser(item) {
      this.userIdForRemoveKeepingSector = item.usuario_id;
      this.removeModal = true;
    },
    async initUsers() {
      const { data, errors } = await services.users.getUsers();
      if (!errors) {
        data.filter((item) => {
          if (
            !this.linkedUsers.find(
              (user) => user.usuario_id === item.usuario_id
            )
          ) {
            this.users.push(item);
          }
        });

        this.users = this.users.map((item) => {
          return {
            ...item,
            name: item.usuario_nome,
          };
        });
      }
    },
    async getSubcontractorUsers() {
      const { data, errors } =
        await services.subcontractors.getUsersOfSubcontractorsPaginated(
          this.subcontractorId,
          this.pagination
        );
      if (!errors) {
        this.subcontractorUsers = data;
      }
    },
    async infiniteHandler($state) {
      this.pagination.page++;
      const { data, errors } =
        await services.subcontractors.getUsersOfSubcontractorsPaginated(
          this.subcontractorId,
          this.pagination
        );
      if (!errors) {
        if (data.length > 0) {
          data.forEach((item) => {
            this.subcontractorUsers.push(item);
          });
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    async removeKeepingSector() {
      const { errors } = await services.users.removeKeepingSectorFromUser({
        usuario_id: this.userIdForRemoveKeepingSector,
      });
      if (!errors) {
        await this.getUsersOfSubcontractors();
        await this.initUsers();
        (this.removeModal = false),
          this.validationToast(
            {
              data: {
                message: this.$t("successRemoveKeepingSector"),
              },
            },
            "success"
          );
      }
    },
    validationToast(err, type) {
      Vue.$toast.open({
        message: err.data.error || err.data.message || err.data.erro,
        position: "top",
        type: type,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.subcontractor-users {
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .table-options {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    gap: 20px;

    div {
      cursor: pointer;
    }
  }

  .keeping-sector-badge {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 8px;
    gap: 4px;
    width: 100px;
    background: #dddee3;
    border-radius: 6px;
    color: #565e73;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
  }

  .fix-badge {
    margin-bottom: 6px;
  }
}
</style>
